import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { types } from '../actions/bikesManagementActions';

export default function bikeServiceHistoryReducer(state = Immutable(initialState.bikeServiceHistory), action) {
  switch (action.type) {
    case types.GET_BIKE_SERVICE_HISTORY: {
      return Object.assign({}, state, { data: [], fetching: true });
    }
    case types.GET_BIKE_SERVICE_HISTORY_SUCCESS: {
      return Object.assign({}, state, { data: action.data, fetching: false });
    }
    case types.CONFIRM_BIKE_SERVICE_SUCCESS: {
      const { time, note, operatorName } = action;
      return Object.assign({}, state, { data: [{ time, note, operatorName }, ...state.data] });
    }
    case types.GET_BIKE_SERVICE_HISTORY_FAILURE: {
      return Object.assign({}, state, { data: [], fetching: false });
    }
    default:
      return state;
  }
}
